// ================================================================
// Start Node — Definition
// ================================================================

import { startConfigSchema } from './config-schema.js';

export const startDefinition = {
  type: 'start',

  nameKey: 'nodes.start.name',
  subtitleKey: 'nodes.start.subtitle',
  modalTitleKey: 'nodes.start.title',

  icon: 'play_arrow',
  color: '#1A73E8',
  colorGradient: 'linear-gradient(135deg, #4F94ED, #1A73E8)',

  // وقتی روی این node کلیک می‌شه، به جای modal تنظیمات، Picker باز شه
  clickAction: 'openPicker',

  // در picker نشون داده نشه (چون trigger هست، نمی‌شه دو تا داشت)
  hideFromPicker: true,

  schema: startConfigSchema
};
